import { z } from './utils/zod.js';
import { dataResponse, deleteResponse, listResponse } from './utils/response-templates.js';
import { mcpScopeSchema } from './mcp.js';
export const OAUTH_GRANT_TYPES = ['authorization_code', 'refresh_token'];
export const OAUTH_RESPONSE_TYPES = ['code'];
export const OAUTH_TOKEN_ENDPOINT_AUTH_METHODS = ['none', 'client_secret_post', 'client_secret_basic'];
export const oauthTokenEndpointAuthMethodSchema = z.enum(OAUTH_TOKEN_ENDPOINT_AUTH_METHODS);
const uriSchema = z.string().url().max(2000);
export const oauthClientRegistrationRequestSchema = z.object({
    client_name: z.string().trim().min(1).max(200),
    redirect_uris: z.array(uriSchema).min(1).max(10),
    grant_types: z.array(z.string().max(100)).max(10).optional(),
    response_types: z.array(z.string().max(100)).max(10).optional(),
    token_endpoint_auth_method: oauthTokenEndpointAuthMethodSchema.optional(),
    scope: z.string().max(500).optional(),
    client_uri: uriSchema.optional(),
    logo_uri: uriSchema.optional(),
});
export const oauthClientRegistrationResponseSchema = z.object({
    client_id: z.string(),
    client_id_issued_at: z.number().int(),
    client_secret: z.string().optional(),
    client_secret_expires_at: z.number().int().optional().openapi({ description: '0 = the secret never expires' }),
    client_name: z.string(),
    redirect_uris: z.array(z.string()),
    grant_types: z.array(z.string()),
    response_types: z.array(z.string()),
    token_endpoint_auth_method: oauthTokenEndpointAuthMethodSchema,
    scope: z.string().optional(),
    client_uri: z.string().optional(),
    logo_uri: z.string().optional(),
});
export const oauthTokenResponseSchema = z.object({
    access_token: z.string(),
    token_type: z.literal('Bearer'),
    expires_in: z.number().int(),
    refresh_token: z.string(),
    scope: z.string(),
});
export const oauthErrorResponseSchema = z.object({
    error: z.string(),
    error_description: z.string().optional(),
});
export const oauthAuthorizationViewSchema = z.object({
    id: z.string(),
    client: z.object({
        name: z.string(),
        redirectDomain: z.string(),
        knownHost: z.boolean(),
        clientUri: z.string().optional(),
        logoUri: z.string().optional(),
    }),
    scopes: z.array(z.object({
        id: mcpScopeSchema,
        description: z.string(),
    })),
    expiresAt: z.string().datetime(),
});
export const oauthAuthorizationViewResponseSchema = dataResponse(oauthAuthorizationViewSchema);
export const oauthDecisionRequestSchema = z.object({
    approve: z.boolean(),
    scopes: z.array(mcpScopeSchema).optional().openapi({ description: 'May only narrow the requested scopes' }),
});
export const oauthDecisionResponseSchema = z.object({
    redirectTo: z.string(),
});
export const oauthDecisionSuccessResponseSchema = dataResponse(oauthDecisionResponseSchema);
export const oauthConnectionDtoSchema = z.object({
    id: z.string().uuid(),
    clientName: z.string(),
    scopes: z.array(z.string()),
    createdAt: z.string().datetime(),
    lastUsedAt: z.string().datetime().nullable(),
    expiresAt: z.string().datetime(),
});
export const listOAuthConnectionsResponseSchema = listResponse(oauthConnectionDtoSchema);
export const deleteOAuthConnectionResponseSchema = deleteResponse();
